/* eslint-disable react-hooks/exhaustive-deps */
import { ApiKeyFetch } from "api/fetchers/apiKey";
import { dataUsuarioVacio } from "constants/index";
import { urlValidacionesRecuperacionV2 } from "constants/urls";
import useCustomRouter from "hooks/useCustomRouter";
import useCustomToast from "hooks/useCustomToasts";
import useUsuario from "hooks/useUsuario";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { dataUsuario } from "redux/actions/aLogin";
import { getQueryParams } from "utils/funciones";
import Loading from "wrappers/Loading";

const withValidarRecuperar = (Component, codProducto, options) => (props) => {
  const QParams = getQueryParams();

  const UseParams = useParams();

  const { idCotizacion, idPoliza: idPolizaEmision } = UseParams;

  const { idPoliza } = QParams;

  const [estadoGeneral, setEstadoGeneral] = useState({});

  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  const history = useCustomRouter();

  const { addWarningToast } = useCustomToast();

  const { userIsLoggedIn, correo } = useUsuario();

  const { isPolizaPagada, mensajePolizaPagada } = useMemo(
    () => ({
      isPolizaPagada: estadoGeneral?.polizaPagada?.validacion || false,
      mensajePolizaPagada: estadoGeneral?.polizaPagada?.msgError || null,
    }),
    [estadoGeneral]
  );

  const init = useCallback(async () => {
    setLoading(true);
    const DataResumen = {
      prodCodigoCore: codProducto,
      idCotizacion: idCotizacion,
      idPoliza: idPoliza || idPolizaEmision,
    };

    let res = await ApiKeyFetch.instance().post(urlValidacionesRecuperacionV2, DataResumen);

    if (res?.transaccion) {
      if (res?.redirectHome) {
        addWarningToast(res?.redirectHome);
        return history.push("/");
      }

      if (props?.validations?.prePolizaPagada && res?.polizaPagada?.validacion) {
        addWarningToast(res?.polizaPagada?.msgError);
        return history.push("/");
      }

      if (res?.bloquearPago) {
        addWarningToast(res?.bloquearPago);
        res.bloquearPago = true;
      }

      if (res?.meta?.canal) {
        /* COMENTADO POR TICKET 1400
        if (res?.meta?.canal?.isDtc && userIsLoggedIn && res?.meta?.creador?.correo !== correo) {
          console.log("VALIDACION DTC");
          localStorage.setItem("login", false);
          dispatch(dataUsuario(dataUsuarioVacio));
        }*/
      }
      setEstadoGeneral(res);
    } else {
      addWarningToast("Ha ocurrido un problema al intentar recuperar");
      history.push("/");
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    init();
  }, [init]);

  const onPolizaPagada = () => {
    addWarningToast(mensajePolizaPagada);
  };

  const onValidarPago = useCallback(
    (onNoPagada, onPagada = onPolizaPagada) => {
      if (isPolizaPagada) {
        onPagada();
      } else {
        onNoPagada();
      }
    },
    [isPolizaPagada, mensajePolizaPagada]
  );

  return (
    <React.Fragment>
      <Loading loading={loading}>
        {!loading && (
          <Component
            {...props}
            estadoGeneral={estadoGeneral}
            isPolizaPagada={isPolizaPagada}
            mensajePolizaPagada={mensajePolizaPagada}
            onValidarPago={onValidarPago}
          />
        )}
      </Loading>
    </React.Fragment>
  );
};

export default withValidarRecuperar;
